import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { RejectedReason } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useState } from 'react';

import ConfirmationDialog from '~components/Dialog/ConfirmationDialog';

import { rejectedReasonKeys } from './RejectedChip';

interface RejectLineDialogProps {
  isBusy: boolean;
  reasons: RejectedReason[];
  initialReason: RejectedReason;
  onClose: () => void;
  onConfirm: (reason: RejectedReason) => void;
}

// Mounted only while open, so the chosen reason starts over for every line
export default function RejectLineDialog({
  isBusy,
  reasons,
  initialReason,
  onClose,
  onConfirm,
}: RejectLineDialogProps) {
  const [reason, setReason] = useState(initialReason);

  return (
    <ConfirmationDialog
      confirmButtonProps={{
        children: t('approvals.approve_charges.reject_dialog.confirm'),
      }}
      isBusy={isBusy}
      isOpen
      onClose={onClose}
      onConfirm={() => onConfirm(reason)}
      title={t('approvals.approve_charges.reject_dialog.title')}
    >
      <Typography variant="body2" sx={{ mb: 2 }}>
        {t('approvals.approve_charges.reject_dialog.description')}
      </Typography>
      <TextField
        disabled={isBusy}
        fullWidth
        label={t('approvals.approve_charges.reject_dialog.reason')}
        onChange={(event) => {
          const pickedReason = reasons.find((option) => option === event.target.value);
          if (pickedReason) {
            setReason(pickedReason);
          }
        }}
        select
        size="small"
        value={reason}
      >
        {reasons.map((option) => (
          <MenuItem key={option} value={option}>
            {t(rejectedReasonKeys[option])}
          </MenuItem>
        ))}
      </TextField>
    </ConfirmationDialog>
  );
}
